import LinkIcon from "assets/icons/LinkIcon";
import styles from "./style.module.scss";

export function CustomNameStringIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2.66602 5.33366V4.00033C2.66602 3.6467 2.80649 3.30756 3.05654 3.05752C3.30659 2.80747 3.64573 2.66699 3.99935 2.66699H5.33268"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66602 10.667V12.0003C2.66602 12.3539 2.80649 12.6931 3.05654 12.9431C3.30659 13.1932 3.64573 13.3337 3.99935 13.3337H5.33268"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.666 2.66699H11.9993C12.353 2.66699 12.6921 2.80747 12.9422 3.05752C13.1922 3.30756 13.3327 3.6467 13.3327 4.00033V5.33366"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.666 13.3337H11.9993C12.353 13.3337 12.6921 13.1932 12.9422 12.9431C13.1922 12.6931 13.3327 12.3539 13.3327 12.0003V10.667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.13672 10.6667V6"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.13672 6H10.1367"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function GeolocationIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6 7.33398C6 7.86442 6.21071 8.37313 6.58579 8.7482C6.96086 9.12327 7.46957 9.33398 8 9.33398C8.53043 9.33398 9.03914 9.12327 9.41421 8.7482C9.78929 8.37313 10 7.86442 10 7.33398C10 6.80355 9.78929 6.29484 9.41421 5.91977C9.03914 5.5447 8.53043 5.33398 8 5.33398C7.46957 5.33398 6.96086 5.5447 6.58579 5.91977C6.21071 6.29484 6 6.80355 6 7.33398Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7707 11.1045L8.94202 13.9331C8.69201 14.1829 8.35307 14.3232 7.99968 14.3232C7.6463 14.3232 7.30736 14.1829 7.05735 13.9331L4.22802 11.1045C3.48217 10.3586 2.97424 9.40827 2.76848 8.37371C2.56271 7.33916 2.66834 6.26681 3.07202 5.29229C3.4757 4.31777 4.15928 3.48483 5.03634 2.89881C5.9134 2.31279 6.94453 2 7.99935 2C9.05417 2 10.0853 2.31279 10.9624 2.89881C11.8394 3.48483 12.523 4.31777 12.9267 5.29229C13.3304 6.26681 13.436 7.33916 13.2302 8.37371C13.0245 9.40827 12.5165 10.3586 11.7707 11.1045Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DateTimeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.99935 14.0007H3.99935C3.64573 14.0007 3.30659 13.8602 3.05654 13.6101C2.80649 13.3601 2.66602 13.0209 2.66602 12.6673V4.66732C2.66602 4.3137 2.80649 3.97456 3.05654 3.72451C3.30659 3.47446 3.64573 3.33398 3.99935 3.33398H11.9993C12.353 3.33398 12.6921 3.47446 12.9422 3.72451C13.1922 3.97456 13.3327 4.3137 13.3327 4.66732V6.66732"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.666 2V4.66667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33398 2V4.66667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66602 7.33398H9.33268"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33398 12.0007C9.33398 12.7079 9.61494 13.3862 10.115 13.8863C10.6151 14.3864 11.2934 14.6673 12.0007 14.6673C12.7079 14.6673 13.3862 14.3864 13.8863 13.8863C14.3864 13.3862 14.6673 12.7079 14.6673 12.0007C14.6673 11.2934 14.3864 10.6151 13.8863 10.115C13.3862 9.61494 12.7079 9.33398 12.0007 9.33398C11.2934 9.33398 10.6151 9.61494 10.115 10.115C9.61494 10.6151 9.33398 11.2934 9.33398 12.0007Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11V12L12.3333 12.3333"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CustomNameNumberIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3.33398 6H12.6673"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33398 10H12.6673"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.33268 2.66602L4.66602 13.3327"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3327 2.66602L8.66602 13.3327"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CustomNameEnumIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6 4H13.3333"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 8H13.3333"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 12H13.3333"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33398 4V4.00667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33398 8V8.00667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33398 12V12.0067"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CustomLinkIcon() {
  return (
    <div className={styles.linkIcon}>
      <LinkIcon />
    </div>
  );
}
